/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'townsquare.townsquare-tags.tag': 'Tag entfernen',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, one {An {usageCount,number} Ort verwendet} other {An {usageCount,number} Orten verwendet}}',
};
